import {copyToClipboard, rgba2hex} from 'methods/utils';

document.addEventListener('click', e => {
    const $element = e.target;
    if (!$element.matches('.copy-icon')) {
        return;
    }

    const $card = $element.closest('.colors-block__card');
    const $tooltip = $card.querySelector('.tooltip');
    const styles = window.getComputedStyle($card);

    copyToClipboard(rgba2hex(styles.backgroundColor).toUpperCase());

    $tooltip.innerText = 'Скопировано';
});

document.addEventListener('mouseout', e => {
    const $element = e.target
    if (!$element.matches('.copy-icon')) {
        return;
    }

    const $card = $element.closest('.colors-block__card');
    const $tooltip = $card.querySelector('.tooltip');

    $element.nextElementSibling.innerText = 'Копировать';
});
